import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  constructor() {
  }

  public hasLargeScreen() {
    return this.getScreenWidth() > 600 ? true : false;
  }

  public screenSizeBiggerThan(_width: number) {
    return this.getScreenWidth() > _width ? true : false;
  }

  public screenSizeSmallerThan(_width: number) {
    return this.getScreenWidth() < _width ? true : false;
  }

  private getScreenWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }
}
